import {createStylesParams} from '@wix/yoshi-flow-editor/tpa-settings';

type IStylesParams = {};

export default createStylesParams<IStylesParams>({});
